<div class="secure-deal-container">
  <div class="secure-deal-banner">
    <img
      src="https://storage.googleapis.com/dev-ps-asset/motor/d2c/locked-deal.png"
      alt=""
    />
  </div>

  <div>
    <div class="secure-deal-title">
      <mat-icon class="icon-tick"> check_circle_outline </mat-icon>
      <span>
        {{ "renewal.dealLockedIn" | translate }}
      </span>
    </div>

    <div class="secure-deal-content">
      <div>
        {{ "renewal.dealSecuredSuccess" | translate }}
      </div>
      <div>
        {{ "renewal.autoApplyDiscount" | translate }}
      </div>
      <div>
        {{ "renewal.noWorries" | translate }}
      </div>
    </div>
  </div>

  <div class="button-wrapper">
    <button mat-flat-button mat-dialog-close class="white-btn">
      {{ "renewal.close" | translate }}
    </button>
  </div>
</div>
